import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';

class ProcedureDetail extends Component {
  /**************
   * Properties *
   **************/
  state = {
    hipXRay: {
      pages: [require('./images/detail_hip_xray_pg1.png')]
    },
    chestXRay: {
      pages: [
        require('./images/detail_chest_xray_pg1.png')
      ]
    },
    xray: {
      pages: [
        require('./images/detail3_xray_pg1.png'),
        require('./images/detail3_xray_pg2.png'),
        require('./images/detail3_xray_pg3.png')
      ]
    },
    angiogram: {
      pages: [require('./images/detail4_angio_pg1.png'), require('./images/detail4_angio_pg2.png')]
    },
    bloodTest: {
      pages: [
        require('./images/detail_bloodTest_pg1.png')
      ]
    },
    echocardiogram: {
      pages: [
        require('./images/detail_echocardiogram_pg1.png')
      ]
    },
    pulmonary: {
      pages: [
        require('./images/detail_Pulmonary_pg1.png')
      ]
    },
    bloodtestBedside: {
      pages: [
        require('./images/detail_bloodtestBedSide.png')
      ]
    },
    petScan: {
      pages: [
        require('./images/detail_petScan.png')
      ]
    },
    textImage: require('./images/1259_elements_details.png'),
    arrowUp: require('../common/images/Arrow_up.png'),
    arrowDown: require('../common/images/Arrow_down.png'),
    navigationBar: {
      back: true,
      backRoute: '/scheduled_procedures/list',
      mainMenu: true,
      navigate: true
    }
  };

  /*******************
   * Private methods *
   *******************/

  getCurrentPageIndex = () => {
    const currentProc = this.getCurrentProcedure();
    let pageNumber = this.props.match.params.page - 1;
    if (pageNumber < 0) {
      pageNumber = 0;
    } else if (pageNumber >= currentProc.pages.length) {
      pageNumber = currentProc.pages.length - 1;
    }
    return pageNumber;
  };

  getCurrentProcedure = () => {
    return this.state[this.props.match.params.name];
  };

  goToPage = pageNumber => {
    const currentProc = this.props.match.params.name;
    this.props.history.push(`/scheduled_procedures/details/${currentProc}/${pageNumber}`);
  };

  handlePageUp = () => {
    const nextPageNumber = parseInt(this.props.match.params.page, 10) + 1;
    if (nextPageNumber <= this.getCurrentProcedure().pages.length) {
      this.goToPage(nextPageNumber);
    }
  };

  handlePageDown = () => {
    const nextPageNumber = parseInt(this.props.match.params.page, 10) - 1;
    if (nextPageNumber > 0) {
      this.goToPage(nextPageNumber);
    }
  };

  handleOnKeyUp = event => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case 'ArrowDown':
        this.handlePageUp();
        break;
      case 'ArrowUp':
        this.handlePageDown();
        break;
      default:
    }
  }

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const currentProc = this.getCurrentProcedure();
    const pageIndex = this.getCurrentPageIndex();
    return (
      <div className="procedure-detail">
        <ImageText id="text" src={this.state.textImage} />
        <img className="details" src={currentProc.pages[pageIndex]} alt="" />
        {currentProc.pages.length > 1 && (
          <div className="arrows">
            <img className="arrow-up" src={this.state.arrowUp} alt="" />
            <img className="arrow-down" src={this.state.arrowDown} alt="" />
          </div>
        )}
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedProcedureDetail = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(ProcedureDetail);

export default withRouter(ConnectedProcedureDetail);
